export const SEMRUSH_SIDEBAR_WIDTH = 350
export const SEMRUSH_SIDEBAR_ANIMATION_TIME = 300 // milliseconds
